import React from 'react'
import { Stack, Typography } from '../../ui-kit'
import { useVersionState } from '../../state'
import * as S from './Version.styles'

interface VersionProps {
  isOpen: boolean
}

export const Version: React.FC<VersionProps> = ({ isOpen }) => {
  const [{ version, isNew }] = useVersionState()

  if (!version) return null

  const renderVersionText = (isShort: boolean) => (
    <Stack align="center" gap="xxs" wrap justify={isShort ? 'center' : 'start'}>
      <Typography variant="body1-sm" color="grey5">
        {isShort ? `V ${version}` : `Version ${version}`}
      </Typography>
      {isNew && (
        <Typography variant="body1-sm" color="yellow">
          NEW
        </Typography>
      )}
    </Stack>
  )

  return (
    <S.Container>
      <S.Link to="/changelog" $variant="wide" $isOpen={isOpen}>
        {renderVersionText(false)}
      </S.Link>
      <S.Link to="/changelog" $variant="short" $isOpen={isOpen}>
        {renderVersionText(true)}
      </S.Link>
    </S.Container>
  )
}
